

class POSMProgressBar extends HTMLElement {
    constructor() {
        super();
        this.allowRefresh = this.dataset.allowRefresh === 'true' ? true : false;
        
    }
    
    
    
    connectedCallback() {
        if (this.allowRefresh) {
            
            this.init();
        }
    }

    init() {
        
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
        
    }

    handleCartUpdate() {
        console.log('test')
        const url = new URL(window.location.href)
        url.searchParams.set('section_id', 'fetch-posm-progress');
        console.log(url)
        const data = fetch(`${url}`).then(data => data.text()).then((text) => {
            const parsedHtml = new DOMParser().parseFromString(text, 'text/html');
            const source = parsedHtml.querySelector('posm-progress');
            const destination = this;
            console.log(source)
            
            if (source && destination) {
                destination.innerHTML = source.innerHTML;
            }
        })
    }
}



customElements.define('posm-progress', POSMProgressBar);